import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { Route } from "@mapmycustomers/shared/types/entity";
import ViewState from "@mapmycustomers/shared/types/viewModel/ViewState";

import { FetcherPayload } from "@app/types/viewModel/Fetcher";

export const initializeUpcomingView = createAsyncAction(
  "route/upcomingView/initialize/request",
  "route/upcomingView/initialize/success",
  "route/upcomingView/initialize/failure"
)<void, void, unknown>();

export const applyUpcomingViewStateSettings = createAction("route/upcomingView/applySettings")<
  Partial<ViewState>
>();

export const fetchUpcomingRoutes = createAsyncAction(
  "route/upcomingView/fetch/request",
  "route/upcomingView/fetch/success",
  "route/upcomingView/fetch/failure"
)<
  FetcherPayload<Route>,
  { routes: Route[]; totalFilteredRecords: number; totalRecords: number },
  unknown
>();

export type Actions = ActionType<
  typeof applyUpcomingViewStateSettings | typeof fetchUpcomingRoutes | typeof initializeUpcomingView
>;
